import React, { useState } from 'react';
import { useHistory } from "react-router-dom";
import {useTranslation} from "react-i18next";
import Title from '../../../components/Title';
import FormButton from '../../../components/forms/FormButton';
import {PublisherUserForm} from "../../../components/publisher/PublisherUserForm";
import {useCreateUserMutation} from "../../../api/userApiSlice";

export default function NewPublisherUser(props) {
  const { t } = useTranslation();
  const history = useHistory();
  const [createUser] = useCreateUserMutation();
  const [submitButtonProps, setSubmitButtonProps] = useState({})

  const goToUser = (data) => history.push(`/users/${data.slug}`)

  const handleSubmit = (data) => {
    createUser({user: data}).unwrap()
      .then(goToUser)
      .catch(error => {})
  }

  return (
    <>
      <Title main={t("menu.users")} sub={t('users.new')} group={false} backPath="/users">
        <FormButton submit {...submitButtonProps}/>
      </Title>
      <PublisherUserForm handleSubmit={handleSubmit} setSubmitButtonProps={setSubmitButtonProps} canSelectRole={false}/>
    </>
  )
}




